<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Have a suggestion or question?</h3>
                    <h4 class="mb-0 font-weight-light">Fill out the form to get in touch.</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href="https://docs.google.com/forms/d/e/1FAIpQLSfny3bJ_una7lvP8TBzDzdK06JkCDRweVi5oZTeqQUCO381Kw/viewform?usp=sf_link">
                       <base-button type="primary" icon="ni ni-send">Contact</base-button>
                    </a>
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a>Area Reveal</a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
